var exports = {
  "kL": "x7be19a29--318961--container",
  "hl": "x7be19a29--318961--address",
  "BK": "x7be19a29--318961--address-text",
  "xH": "x7be19a29--318961--undergrounds",
  "O3": "x7be19a29--318961--underground",
  "kB": "x7be19a29--318961--time",
};

module.exports = exports;
